import React from 'react';

import { PAYMENT_METHODS, PaymentMethodT } from '@consumer-frontend/nc-utils';

export type NcPaymentAccountLabelPropsT = {
  accountLast4: string;
  paymentType: PaymentMethodT;
  routingLast4?: string;
};

export type NcPaymentAccountLabelT = React.FC<NcPaymentAccountLabelPropsT>;

export const NcPaymentAccountLabel: NcPaymentAccountLabelT = ({
  accountLast4,
  paymentType,
  routingLast4,
}) => {
  const accountTypeStr = paymentType === PAYMENT_METHODS.ACH ? 'Bank account' : 'Debit card';

  return (
    <p className="nc-payment-account-label">
      <span>{`${accountTypeStr} (...${accountLast4})`}</span>
      {!!routingLast4 && <span>{`Routing number (...${routingLast4})`}</span>}
    </p>
  );
};
